import {ComponentProps} from "react";

interface IProps extends ComponentProps<"path"> {
}

const InfoToast = ({...props}: IProps) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15ZM9.75 7.875V11.25H10.5V12.75H7.5V11.25H8.25V9.375H7.5V7.875H9.75ZM10.125 6C10.125 6.62132 9.6213 7.125 9 7.125C8.3787 7.125 7.875 6.62132 7.875 6C7.875 5.37868 8.3787 4.875 9 4.875C9.6213 4.875 10.125 5.37868 10.125 6Z" fill="currentColor"/>
  </svg>
);

export default InfoToast;


